export interface DateMaskInputProps {
    dateFormatPattern: string;
    dateValue: string;
    name: string;
}
